/**
 * Cross-module X XWP-74 (CP §11, §15.20; XO-14) — « Ouvrir <page> dans une nouvelle fenêtre ? », the
 * shell's one question before a supporting page opens from a form with work in progress. It states
 * the consequence first (the form stays open, nothing lost or saved), then offers: open in a new window
 * (primary, Entrée), the caller's same-window choice when it has one (a round trip that keeps the form,
 * or the screen's own leave dialog), Annuler (Échap). Nothing navigates without this answer.
 * Mounted once by the AppShell; fed by stores/fenetreSourceStore.js.
 */
import * as React from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { Alert } from "@/components/ui/Alert";
import { useFenetreSourceStore } from "@/stores/fenetreSourceStore.js";
import { choisirIci, confirmerNouvelleFenetre } from "@/hooks/useFenetreSource.js";
import { M_FENETRE } from "@/config/fenetre-source.messages.js";

export function OuvrirFenetreDialog() {
  const demande = useFenetreSourceStore((s) => s.demande);
  const fermer = useFenetreSourceStore((s) => s.fermer);
  if (!demande) return null;
  return (
    <Modal
      open
      onClose={fermer}
      size="md"
      title={M_FENETRE.titre(demande.page)}
      footer={
        <>
          <Button variant="ghost" shortcut="Échap" onClick={fermer}>
            {M_FENETRE.annuler}
          </Button>
          {demande.ici && (
            <Button variant="secondary" onClick={() => choisirIci()}>
              {demande.ici.libelle}
            </Button>
          )}
          <Button
            variant="primary"
            icon="external-link"
            shortcut="Entrée"
            data-dialog-primary=""
            data-testid="fenetre-ouvrir"
            onClick={() => confirmerNouvelleFenetre()}
          >
            {M_FENETRE.ouvrir}
          </Button>
        </>
      }
    >
      <div data-fenetre-dialogue="" className="space-y-3">
        <p>{demande.phrase}</p>
        <p className="text-text-muted">{M_FENETRE.retourAide}</p>
        {demande.erreur && (
          <Alert variant="warn">
            <span role="alert">{demande.erreur}</span>
          </Alert>
        )}
      </div>
    </Modal>
  );
}

export default OuvrirFenetreDialog;
